<div class="modal">
  <p>Consent to Use Electronic Signatures

    By signing and continuing, you acknowledge and agree that:
    
    You consent to the use of electronic signatures in place of traditional handwritten signatures.
    Your electronic signature will have the same legal effect as a handwritten signature.
    You are authorized to use the electronic signature and understand its binding nature.
    You have been provided with the opportunity to review the terms of this agreement, and by continuing, you accept those terms.
    You have the ability to access, receive, and retain electronic records related to this agreement.
    Access to Electronic Records
    
    To proceed with this transaction, you must have access to the internet and a device capable of viewing and retaining electronic records. If you cannot access or view these records, please contact us for an alternative solution.</p>
  <canvas #canvas class="signature-canvas"></canvas>
  <button nz-button nzType="primary" (click)="save()">Save</button>
  <button nz-button nzType="default" (click)="clear()">Clear</button>
</div>